<template>
  <v-container class="event-selector-container">
    <v-row dense row wrap class="event-selector-row">
      <v-col
        @click="toggleExpand"
        class="col-10"
        :class="{
          clickable: expandable,
        }"
      >
        <img v-if="imgSrc" :src="imgSrc" :alt="topic.plural" />
        <span class="ml-4 name-label application-heading"
          >{{ topic.plural
          }}<span v-if="topicFilterCounts" class="hyp-total"
            >{{ formatFilterCount(topicFilterCounts, topic) }}
          </span>
        </span>
      </v-col>
      <v-col class="col-2">
        <v-switch
          v-model="switchEnabled"
          @click="toggleSwitch({ mapAll: true })"
          class="event-input-toggle pa-0 ma-0 mt-1"
          solo
          item-text="display"
        ></v-switch>
      </v-col>
    </v-row>
    <!-- TODO more X isn't showing up last anymore which sucks... -->
    <v-row dense row wrap class="mt-3">
      <v-col class="col-12">
        <ul v-if="this.expanded" class="category-list">
          <li :key="index" v-for="(item, index) in availableItems">
            <v-checkbox
              v-model="item.enabled"
              @click="handleSubtopicChange(item)"
              class="category-input"
              dense
            >
              <template v-slot:label>
                <span class="application-heading">{{ item.plural }}</span>
                <span class="hyp-total">{{
                  formatFilterCount(topicFilterCounts, item)
                }}</span>
              </template>
            </v-checkbox>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//TODO cull unused imports
import lodashFind from "lodash/find";
import lodashGet from "lodash/get";
import lodashDebounce from "lodash/debounce";

import { ICONS } from "@/common/constants/icons";
import {
  getTopicsArray,
  getTopicKey,
  isTopicSelected,
  isSubtopicSelected,
  modifyTopicString,
  getTopicImmediateChildren,
  getTopicsArraySpecial,
} from "@/services/events/topics.service";
import { formatBigNumber } from "@/common/basic.utilities";

const EMITTED_ACTIONS = {
  CHANGED: "changed",
  EXPANDED: "expanded",
};

export default {
  name: "EventPickerV3",
  props: {
    topic: {
      topic: Object,
      required: true,
    },
    selectedTopics: {
      type: String,
    },
    //TODO get rid of references to this...
    // selectedSubtopics: {
    //   type: Array,
    // },
    // TODO do we need reset?
    reset: {
      type: String,
    },
    total: {
      type: Number,
    },
    topicFilterCounts: {
      type: Object,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    //TODO what is mapall even for?
    mapAll: {
      type: Object,
    },
    // topics: {
    //   type: Array,
    // },
  },
  data() {
    return {
      availableItems: [],
      previousSelectedTopics: null,
      switchEnabled: false,
    };
  },
  computed: {
    topics() {
      let topics = [];
      if (this.topic) {
        topics = getTopicsArraySpecial();
      }
      return topics;
    },
    //TODO get rid of calls that set this... jesus god lord
    imgSrc() {
      let imgSrc, src;
      try {
        if (!ICONS) {
          return null;
        }
        src = ICONS.types[this.topic.type].active;
        if (this.switchEnabled) {
          src = ICONS.types[this.topic.type].inactive;
        }
        imgSrc = require(`@/assets/images${src}`);
      } catch (err) {
        src = ICONS.types["events_general"].active;
        if (this.switchEnabled) {
          src = ICONS.types["events_general"].inactive;
        }
        imgSrc = src;
      }
      return imgSrc;
    },
    expandable() {
      return lodashGet(this, "topic.subtopics.length") > 0;
    },
    hasSubtopics() {
      return (
        this.topic && this.topic.subtopics && this.topic.subtopics.length > 0
      );
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    _subtopicSelected(subtopic) {
      let res =
        isTopicSelected(
          subtopic.apiName,
          this.selectedTopics,
          getTopicsArray() //Should use eventType?
        ) ||
        isSubtopicSelected(
          subtopic.apiName,
          this.selectedTopics,
          getTopicsArray() //Should use eventType?
        );
      return (
        isTopicSelected(
          subtopic.apiName,
          this.selectedTopics,
          getTopicsArray() //Should use eventType?
        ) ||
        isSubtopicSelected(
          subtopic.apiName,
          this.selectedTopics,
          getTopicsArray() //Should use eventType?
        )
      );
      // return true;
    },
    determineSwitchEnabled() {
      let res = false;
      if (
        isTopicSelected(
          this.topic.apiName,
          this.selectedTopics,
          getTopicsArray() //Should use eventType?
        )
      ) {
        res = true;
      }

      if (this.topic.subtopics) {
        this.topic.subtopics.forEach((subtopic) => {
          if (
            isSubtopicSelected(
              subtopic.apiName,
              this.selectedTopics,
              getTopicsArray()
            )
          ) {
            res = true;
          }
        });
      }

      this.switchEnabled = res;
    },
    setupSubtopics() {
      if (
        this.topic.subtopics &&
        Array.isArray(this.topic.subtopics) &&
        this.topic.subtopics.length
      ) {
        this.availableItems = this.topic.subtopics;
        for (let i = 0; i < this.availableItems.length; i++) {
          this.availableItems[i].enabled = isSubtopicSelected(
            this.availableItems[i].apiName,
            this.selectedTopics,
            getTopicsArray() //Should use eventType?
          );
          // this.$set(
          //   this.availableItems[i],
          //   "enabled",
          //   isSubtopicSelected(
          //     this.availableItems[i].apiName,
          //     this.selectedTopics,
          //     getTopicsArray() //Should use eventType?
          //   )
          // );
          // this.availableItems[i].enabled =
          //   isTopicSelected(this.availableItems[i].apiName, this.selectedTopics) ||
          //   isSubtopicSelected(this.availableItems[i].apiName, this.selectedTopics)
        }
      } else {
        this.availableItems = [];
      }
    },
    initialize() {
      //TODO write me
      this.determineSwitchEnabled();
      this.setupSubtopics();

      let hasSelectedItem = false;
      this.availableItems.forEach((item) => {
        if (item.enabled) {
          hasSelectedItem = true;
        }
      });

      if (
        (this.relevantTopicChanged() && hasSelectedItem && !this.expanded) ||
        (!hasSelectedItem && this.expanded)
      ) {
        this.toggleExpand();
      }

      this.previousSelectedTopics = this.selectedTopics;
    },
    relevantTopicChanged() {
      let relevantTopics = [this.topic.apiName];
      if (this.topic.subtopics) {
        this.topic.subtopics.forEach((subtopic) => {
          relevantTopics.push(subtopic.apiName);
        });
      }

      let old = [];
      if (this.previousSelectedTopics) {
        this.previousSelectedTopics.split(",").forEach((cur) => {
          if (relevantTopics.includes(cur)) {
            old.push(cur);
          }
        });
      }
      old = old.sort().join(",");

      let nu = [];
      if (this.selectedTopics) {
        this.selectedTopics.split(",").forEach((cur) => {
          if (relevantTopics.includes(cur)) {
            nu.push(cur);
          }
        });
      }
      nu = nu.sort().join(",");

      return nu !== old;
    },
    toggleExpand(event, opts) {
      if (this.expandable) {
        //don't close an open section you're turning on
        if (this.switchEnabled && this.expanded && !event) {
          return;
        }

        //don't open a collapsed section you're turning off
        if (!this.switchEnabled && !this.expanded && !event) {
          return;
        }

        let expanded = !this.expanded;
        this.$emit(EMITTED_ACTIONS.EXPANDED, {
          expanded: expanded,
          topic: this.topic.type,
        });
      }
    },
    toggleSwitch(opts = {}) {
      let resultString = modifyTopicString(
        this.topic["apiName"],
        this.switchEnabled,
        this.selectedTopics,
        this.topics,
        "apiName"
      );
      this.$emit(EMITTED_ACTIONS.CHANGED, {
        selectedTopics: resultString,
      });
    },
    handleSubtopicChange(item) {
      let resultString = modifyTopicString(
        item["apiName"],
        item.enabled,
        this.selectedTopics,
        this.topics,
        "apiName"
      );

      this.$emit(EMITTED_ACTIONS.CHANGED, {
        selectedTopics: resultString,
      });
    },
    formatFilterCount(topicFilterCounts, topic) {
      let count = lodashGet(topicFilterCounts, topic.apiName);
      if (count || count === 0) {
        return `(${formatBigNumber(count)})`;
      }
    },
  },
  watch: {
    reset: {
      handler() {
        //TODO write me?
      },
      deep: true,
    },
    mapAll: {
      handler(val) {
        this.switchEnabled = this.mapAll.enabled;
        this.toggleSwitch({ mapAll: this.mapAll.enabled });
      },
      deep: true,
    },
    topic: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    selectedTopics: {
      handler() {
        this.initialize();
      },
    },
  },
};
</script>

<style scoped>
.event-selector-container {
  padding: 0 0 5px 0 !important;
}
.event-selector-row {
  height: 20px;
}
.name-label {
  color: #1c1c1c;
  font-size: 14px !important;
  margin: 0 0 0 5px !important;
  position: relative;
  top: -8px;
}
.topic-image {
  height: 20px;
  width: 20px;
  margin: 0 0 2px 0;
  vertical-align: middle;
}
.category-list {
  list-style-type: none;
  padding: 0 0 0 16px;
}
.category-input {
  margin: 4px;
}
.category-input >>> .v-label {
  color: #1c1c1c;
  font-size: 13px !important;
}
.category-input >>> .v-messages {
  min-height: 0 !important;
}
.category-input >>> .v-input__slot {
  margin: 0 !important;
}
.hyp-total {
  font-size: 12px;
  position: relative;
  top: -1px;
  padding-left: 5px;
}
.clickable {
  cursor: pointer;
}
</style>
